var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBroccoli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3006",
    "data-name": "Group 3006",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.447,
    height: 18.028,
    viewBox: "0 0 18.447 18.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3362",
    "data-name": "Path 3362",
    d: "M2049.328,262.844h-4.134a.366.366,0,0,1-.366-.367,9.443,9.443,0,0,0-1.909-6.051.367.367,0,0,1,.57-.462,8.731,8.731,0,0,1,1.359,2.4,11.338,11.338,0,0,1,.708,3.748h3.412a10.777,10.777,0,0,1,1.23-4.649,8.753,8.753,0,0,1,1.254-1.847.367.367,0,0,1,.531.506,8.236,8.236,0,0,0-1.148,1.705,10.114,10.114,0,0,0-1.14,4.651A.367.367,0,0,1,2049.328,262.844Z",
    transform: "translate(-2037.618 -244.816)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3363",
    "data-name": "Path 3363",
    d: "M2049.966,256.726a.367.367,0,0,1-.351-.262,7.956,7.956,0,0,0-1.725-3.1.367.367,0,1,1,.562-.471,9.825,9.825,0,0,1,1.148,1.625v-1.083a.367.367,0,1,1,.733,0v2.927a.367.367,0,0,1-.367.367Z",
    transform: "translate(-2041.37 -242.744)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3364",
    "data-name": "Path 3364",
    d: "M2062.153,257.352a.7.7,0,0,1-.13-.012.665.665,0,0,1-.546-.66v-3.37a.367.367,0,1,1,.733,0v3.055a13.413,13.413,0,0,1,.769-1.54,12,12,0,0,1,1.432-1.975.367.367,0,1,1,.546.49,11.86,11.86,0,0,0-2.184,3.587A.661.661,0,0,1,2062.153,257.352Z",
    transform: "translate(-2051.7 -242.721)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    "data-name": "Path 3365",
    d: "M2069.909,240.8a.366.366,0,0,1-.334-.216,3.386,3.386,0,0,1,.229-3.195.367.367,0,0,1,.619.393,2.653,2.653,0,0,0-.179,2.5.367.367,0,0,1-.334.517Z",
    transform: "translate(-2057.596 -230.999)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    "data-name": "Path 3366",
    d: "M2030.465,211.791a5.52,5.52,0,0,1,4.488,2.3,2.5,2.5,0,0,1,3.17,2.4,2.45,2.45,0,0,1-.046.473,3.382,3.382,0,1,1-4.378,4.836,5.505,5.505,0,0,1-3.234,1.045,6.255,6.255,0,0,1-2.078-.256,3.635,3.635,0,0,1-1.147.9,3.914,3.914,0,0,1-1.752.386,4,4,0,0,1-3.54-5.875,4.044,4.044,0,0,1,1.056-1.268c-.008-.09-.011-.181-.011-.27a3.249,3.249,0,0,1,3.25-3.25,3.269,3.269,0,0,1,.476.035,5.51,5.51,0,0,1,3.746-1.463Zm4.343,3.106a.366.366,0,0,1-.308-.168,4.794,4.794,0,0,0-7.4-.82.366.366,0,0,1-.333.1,2.517,2.517,0,0,0-3.036,2.462,2.594,2.594,0,0,0,.029.383.366.366,0,0,1-.151.354,3.27,3.27,0,0,0,1.884,5.943,2.913,2.913,0,0,0,2.488-1.214.367.367,0,0,1,.44-.117,4.963,4.963,0,0,0,2.049.3,4.8,4.8,0,0,0,3.109-1.146.367.367,0,0,1,.571.125,2.648,2.648,0,1,0,3.365-3.578.366.366,0,0,1-.214-.459,1.761,1.761,0,0,0-2.346-2.189A.368.368,0,0,1,2034.808,214.9Z",
    transform: "translate(-2021.485 -211.791)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    "data-name": "Path 3367",
    d: "M2029.346,233.864a.366.366,0,0,1-.211-.067,3.247,3.247,0,0,1-1.339-2.165.367.367,0,0,1,.725-.11,2.526,2.526,0,0,0,1.037,1.676.367.367,0,0,1-.212.666Z",
    transform: "translate(-2026.249 -226.463)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M2044.272,220.316a.368.368,0,0,1-.339-.225,2.512,2.512,0,0,0-1.813-1.492.367.367,0,1,1,.147-.718,3.247,3.247,0,0,1,2.343,1.927.367.367,0,0,1-.338.509Z",
    transform: "translate(-2036.854 -216.386)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroccoli);
export default __webpack_public_path__ + "static/media/broccoli.1b08e564eab0869cba603d8c27aa886c.svg";
export { ForwardRef as ReactComponent };